export default __webpack_public_path__ + "static/media/tralive-logo.c9ed4a46.webp";